import React from "react";
import { Backdrop, CircularProgress, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
        backgroundColor: '#a1a1a13b',
        '& .MuiCircularProgress-root.MuiCircularProgress-indeterminate': {
            animationDuration: '400ms'
        },
        '& .MuiCircularProgress-svg': {
            color: '#315CD5'
        }
    },
}))

const WebsiteLoader = (props) => {

    const classes = useStyles();

    return (
        <Backdrop className={classes.backdrop} open={props.loading}>
            <CircularProgress color="inherit" />
        </Backdrop>
    )
}

export default WebsiteLoader;